module.exports = __webpack_public_path__ + "static/media/img-ami-3.bf173c4d.svg";